export const minValue = 20;
export const maxValue = 5000;
export const minAmount = 1;
export const maxAmount = 100;
export const initialValue = 150;
